import React, { useState } from 'react'

import { uploadRegisteredImages } from '../api'
import globalStyles from '../style.module.css'
import { useRegistrationCertificatesStore } from '../stores/registrationCertificateStore'
import { useRegisteredImagesStore } from '../stores/registeredImagesStore'
import Button from '../../../generic/Button'
import { Modal } from '@material-ui/core'
import { toast } from 'sonner'

export const UploadImagesModal = () => {
	const {
		fetchRegisteredImages,
		uploadImagesModalOpen,
		setUploadImagesModalOpen,
		selectedRegistrationCertificate,
		setSearchString,
	} = useRegisteredImagesStore()

	const registrationCertificatesStore = useRegistrationCertificatesStore()

	const [uploading, setUploading] = useState(false)
	const [partnerImageIdsString, setPartnerImageIdsString] = useState('')

	const handleClose = () => {
		setUploadImagesModalOpen(false)
	}

	const submitRegisteredImages = async () => {
		setUploading(true)

		const partnerImageIds = partnerImageIdsString
			.split('\n')
			.flatMap((line) => line.split(','))
			.filter(Boolean)

		try {
			await uploadRegisteredImages({
				partnerImageIds,
				registrationCertificateId:
					selectedRegistrationCertificate.registration_certificate_id,
				clientId: selectedRegistrationCertificate.client_id,
			})
			setUploading(false)
			setSearchString('')
			fetchRegisteredImages(
				selectedRegistrationCertificate.registration_certificate_id,
				{
					isInitialLoad: true,
				},
			)
			const foundRegistrationCertificate =
				registrationCertificatesStore.registrationCertificates.find(
					(registrationCertificate) =>
						registrationCertificate.registration_certificate_id ===
						selectedRegistrationCertificate.registration_certificate_id,
				)

			if (foundRegistrationCertificate) {
				registrationCertificatesStore.incrementRegistrationCertificateImageCount(
					{
						registrationCertificateId:
							selectedRegistrationCertificate.registration_certificate_id,
						incrementImageCountBy: partnerImageIds.length,
					},
				)
			}
			setPartnerImageIdsString('')
			await toast.success('Image IDs successfully added.')
		} catch (e) {
			await toast.error('Something went wrong. Please try again later')
		}
	}

	const handleCancel = () => {
		setPartnerImageIdsString('')
		handleClose()
	}

	return (
		<Modal open={uploadImagesModalOpen} onClose={handleClose}>
			<div
				style={{
					backgroundColor: 'white',
					padding: '20px',
					width: '50vw',
					margin: 'auto',
				}}
			>
				<h3>
					Upload Image IDs to{' '}
					{selectedRegistrationCertificate.registration_certificate_number}
					{selectedRegistrationCertificate.client_name
						? ` (${selectedRegistrationCertificate.client_name})`
						: ''}
				</h3>
				<p>
					Manually type in images, seperated either by a comma or by a new line,
					or both!
				</p>
				<textarea
					style={{ width: '100%', height: '300px' }}
					value={partnerImageIdsString}
					onChange={(e) => setPartnerImageIdsString(e.target.value)}
				/>
				<div style={{ display: 'flex' }}>
					<Button
						className={globalStyles.invisibleButton}
						onClick={handleCancel}
						style={{ marginRight: '10px' }}
					>
						Cancel
					</Button>
					<Button
						onClick={submitRegisteredImages}
						disabled={uploading || !partnerImageIdsString}
					>
						Upload Images
					</Button>
				</div>
			</div>
		</Modal>
	)
}
